import { useStoreFavicon } from '../../Hooks/useStoreFavicon';
import { useStoreTitle } from '../../Hooks/useStoreTitle';
import { useStoreManifest } from '../../Hooks/useStoreManifest';

/** Renders nothing — it only keeps the document head in sync with the store's settings. */
export default function StoreHead() {
    useStoreFavicon();
    useStoreTitle();
    useStoreManifest();
    return null;
}
